export enum DiagnosticOPEEnum {
  GetDiagnosticEvents = "getDiagnosticEvents",
  GetDiagnosticStatus = "getDiagnosticStatus"
}
